const CONFIG_COLOR_PROP = '__color__';
export function logPayload(payload) {
    const debugConfig = localStorage.getItem('SPOTIM_DEBUG_API');
    if (!debugConfig) {
        return;
    }
    if (debugConfig === '*') {
        log(payload);
        return;
    }
    try {
        const debugConfigParsed = JSON.parse(debugConfig || '');
        if (debugConfigParsed && Array.isArray(debugConfigParsed)) {
            let color;
            const shouldLog = debugConfigParsed.some(item => {
                const isObject = typeof item === 'object' && item !== null && !Array.isArray(item);
                if (!isObject) {
                    return false;
                }
                const isMatch = Object.entries(item).every(([key, value]) => {
                    if (key === CONFIG_COLOR_PROP) {
                        return true;
                    }
                    return payload[key] === value;
                });
                if (isMatch) {
                    color = item[CONFIG_COLOR_PROP];
                }
                return isMatch;
            });
            if (shouldLog) {
                log(payload, color);
            }
        }
    }
    catch (error) {
        console.error('Failed to parse SPOTIM_DEBUG_API', error);
    }
}
function log(payload, color = '#823fb5') {
    console.log(`%c Spot.IM Analytics[${payload.type || ''}] %c`, `background: ${color}; color: white`, 'background: transparent; color: unset', payload);
}
